module.exports = {"modifyPassword":"Change Password","expand":"Expand","collapse":"Collapse"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/en-US/qidian.json
// module id = 1UjG
// module chunks = 1